/**
 * Route for `creative-types`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CreativeTypesPage } from "../features/creative-types/CreativeTypesPage";

export const creativeTypesRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/creative-types",
	component: CreativeTypesPage,
});

export default creativeTypesRoute;
